import { z } from 'zod';
export default {
  valueType: ['number', 'percent'],
  valueValidator: z.number().optional().nullable()
};